// Employee Size Options
export const EmployeeNotLookingOption = {
    label: `I'm an Employee (not looking to hire HR)`,
    value: 'employee-not-looking'
  }